import wx from "weixin-js-sdk"
type PathType = 'navigateTo' | 'redirectTo' | 'switchTab' | 'reLaunch'

export function useWXPath() {
  return (type: PathType,url: string) => {
    wx.miniProgram[type]({ url })
  }
}